import React from 'react';
import { Link } from 'react-router-dom';
import Footer from '../components/Footer';

// Example image and logo imports—adjust paths/filenames as needed.
import LogoSVG from '../assets/BantrBoxLogo.svg';
import FeaturedImage3 from '../assets/blog-feature3.jpg';

const BlogPost3 = () => {
  return (
    <div className="bg-white text-gray-800 min-h-screen flex flex-col">
      {/* Header Bar */}
      <header className="bg-[#333333] shadow-sm text-white">
        <div className="max-w-6xl mx-auto px-4 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center">
            <img 
              src={LogoSVG} 
              alt="BantrBox Logo" 
              className="h-12 w-auto"
            />
          </Link>
        </div>
      </header>

      {/* Main Content */}
      <main className="flex-1 py-10 px-4">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl font-bold mb-4 leading-tight">
            Supercharge Your Rivalries: How to Keep Friendly Competition Fun
          </h1>
          <p className="text-sm text-gray-500 mb-6">
            Published: October 10, 2024 • By BantrBox Team
          </p>

          {/* Featured Image */}
          <div className="w-full mb-8">
            <img
              src={FeaturedImage3}
              alt="Friendly Competition"
              className="w-full h-auto rounded-lg shadow-lg object-cover"
            />
          </div>

          <div className="space-y-6 leading-relaxed text-lg">
            <p>
              Have you ever felt that rush of excitement when you challenge a friend to 
              see who can learn a new skill faster or conquer a shared goal first? 
              That’s the essence of BantrBox—energizing your everyday life with 
              playful rivalries. Yet, the magic lies in keeping it all light, engaging, 
              and downright fun. Here are five tips to supercharge your rivalries 
              without ever losing that friendly spark.
            </p>

            <h2 className="text-2xl font-semibold">1. Pick a Challenge That Thrills You Both</h2>
            <p>
              Nothing kills motivation faster than a dull challenge. Instead, choose 
              something you both genuinely care about—like a cooking face-off, a 
              creative photography showdown, or a collaborative building project. 
              Shared enthusiasm keeps everyone committed and excited to push their 
              limits.
            </p>

            <h2 className="text-2xl font-semibold">2. Break It Into Mini-Milestones</h2>
            <p>
              Long-term goals can quickly fade if you can’t celebrate the small wins 
              along the way. Split your challenge into mini-milestones—think weekly 
              progress markers or shorter tasks leading up to a big finale. This way, 
              you keep the energy high and get frequent chances to hype each other up.
            </p>

            <h2 className="text-2xl font-semibold">3. Add a Twist of Creativity</h2>
            <p>
              Sure, you can see who runs the fastest 5K, but why not spice it up by 
              challenging each other to complete it in the most outrageous outfit 
              possible? Or if you’re having a reading challenge, maybe add a side rule 
              to recite your favorite paragraph in a funny accent. Creativity transforms 
              an ordinary rivalry into something unforgettable.
            </p>

            <h2 className="text-2xl font-semibold">4. Check In (and Cheer On)</h2>
            <p>
              A true friendly rivalry isn’t about tearing each other down but offering 
              morale boosts along the way. Leave encouraging messages, swap tips, or 
              even share a quick video update. When the focus is on collective growth 
              rather than one-upmanship, everyone feels supported.
            </p>

            <h2 className="text-2xl font-semibold">5. Turn Losses Into Lessons</h2>
            <p>
              Not every rivalry ends with you on top—and that’s okay! Celebrate your 
              friend’s victory while reflecting on your own journey. Did you discover 
              a new passion or skill you can refine for the next challenge? Harness 
              that momentum, and get ready to try again.
            </p>

            <p>
              Supercharging your rivalries is all about maintaining that sweet spot 
              between spirited competition and mutual support. By picking challenges 
              you care about, staying creative, and celebrating each other’s progress, 
              you’ll keep the BantrBox spirit alive.
            </p>

            <p className="italic">
              So what are you waiting for? Grab a friend, set the stage, and let your 
              imaginations run wild. Because in the world of BantrBox, every challenge 
              is an opportunity to create meaningful memories.
            </p>
          </div>
        </div>
      </main>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default BlogPost3;
